import script from "./ImageUploadPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUploadPreview.vue?vue&type=script&setup=true&lang=js"

import "./ImageUploadPreview.vue?vue&type=style&index=0&id=6dcea3e7&lang=css"

const __exports__ = script;

export default __exports__